function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Drainlayer icon white");

var _ref3 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{mask:url(#c_2_);fill:#0058A8;}\n\t.st3{fill:#FEFEFE;}\n");

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(27 27)"
}, React.createElement("defs", null, React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: -27,
  y: -27,
  width: 100,
  height: 100
}, React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: -27,
  y: -27,
  width: 100,
  height: 100,
  id: "c_2_"
}, React.createElement("g", {
  className: "st0"
}, React.createElement("path", {
  id: "b_2_",
  className: "st1",
  d: "M-27-27H73V73H-27V-27z"
}))), React.createElement("path", {
  className: "st2",
  d: "M73,23c0-27.6-22.4-50-50-50C-4.6-27-27-4.6-27,23c0,27.6,22.4,50,50,50C50.6,73,73,50.6,73,23"
})), React.createElement("path", {
  className: "st3",
  d: "M83.6,49.9c0-18.6-15.1-33.6-33.6-33.6S16.4,31.3,16.4,49.9c0,18.6,15.1,33.6,33.6,33.6S83.6,68.5,83.6,49.9"
}));

var SvgIconDrainlayerWhite = function SvgIconDrainlayerWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconDrainlayerWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-drainlayer-white.653a52d5.svg";
export { ForwardRef as ReactComponent };